import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CarouselForm from '../../../CarouselForm'
import { CarouselItemSizeComponent } from '../CarouselItemSize'
import useQueryGetGeneralSetting from '@/modules/client-setting/api/hooks/useQueryGetGeneralSetting'

export default function CarouselListing() {
	const { data: generalSettings } = useQueryGetGeneralSetting()

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`รายชื่อกลุ่มการรูปสไลด์`}
					description="รายชื่อกลุ่มการรูปสไลด์"
				/>
			</div>
			<Separator />
			{generalSettings && (
				<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
					<div className="space-y-0.5">
						<label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 sm:text-base">
							ขนาดรูปสไลด์
						</label>
					</div>
					<CarouselItemSizeComponent data={generalSettings} />
				</div>
			)}
			<CarouselForm />
		</div>
	)
}
